import { Center, Icon } from "@chakra-ui/react";
import { type ElementType, type FC } from "react";

import type { InferProps } from "@shared/types/misc";

interface Props {
  icon: ElementType;
  iconProps?: InferProps<typeof Icon>;
  containerProps?: InferProps<typeof Center>;
}

export const LeadingIcon: FC<Props> = ({ icon, iconProps, containerProps }) => {
  return (
    <Center
      p={2}
      rounded="lg"
      bg="teal.100"
      color="teal.600"
      _dark={{ bg: "teal.800" }}
      {...containerProps}
    >
      <Icon as={icon} fontSize="xl" {...iconProps} />
    </Center>
  );
};
